// extracted by mini-css-extract-plugin
module.exports = {"compare":"_fk","compareCount":"_fl"};